import { BrowserRouter as Router, Routes, Route, useLocation, useNavigationType } from "react-router-dom";
import { useEffect, useLayoutEffect, useRef } from "react";
import Home from "./pages/Home.jsx";
import ProductsPage from "./pages/ProductGrid.jsx";
import Navbar from "./components/Navbar/Navbar.jsx";
import Footer from "./components/Footer/Footer.jsx";
import ProductDetail from "./pages/ProductDetail.jsx";
import LoginSignupPage from "./components/LoginSignup/LoginSignup.jsx"
import Register from "./components/LoginSignup/Register.jsx"
import OTPVerification from "./components/LoginSignup/OtpVerification.jsx";
import AccountPage from "./pages/AccountPage.jsx";
import CartPage from "./pages/CartPage.jsx";
import CheckoutPage from "./pages/CheckoutPage.jsx";
import OrderTrackingPage from "./pages/OrderTrackingPage.jsx";
import OrderConfirmationPage from "./pages/OrderConfirmationPage.jsx";
import ReviewSubmissionPage from "./pages/ReviewSubmissionPage.jsx";
import AboutPage from "./pages/AboutPage.jsx";
import ContactPage from "./pages/ContactPage.jsx";
import BespokeJewelryPage from "./pages/BespokeJewelryPage.jsx";
import TermsAndConditions from "./pages/TermsAndConditions.jsx";
import PaymentFailedPage from "./pages/PaymentFailedPage.jsx";
import MoreAtJewelboon from "./pages/MoreAtJewelboon.jsx";
import OneEyedCoconutDetails from "./pages/OneEyedCoconutDetails.jsx";

import { AuthProvider } from "./Context/AuthContext.js";
import { CartProvider } from "./Context/CartContext.js";
import { WishlistProvider } from "./Context/WishlistContext.js";
import WishlistPage from "./pages/WishlistPage.jsx";
import ForgotPassword from "./pages/ForgotPassword.jsx";
import ResetPassword from "./pages/ResetPassword.jsx";
import {
  getStoreListingReturnPosition,
  resetDocumentScrollPosition,
} from "./utils/scrollRestoration";

function ScrollRestoration() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const { hash, key, pathname, search } = location;
  const previousPathnameRef = useRef(pathname);

  useEffect(() => {
    if (!("scrollRestoration" in window.history)) {
      return undefined;
    }

    const previousScrollRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";

    return () => {
      window.history.scrollRestoration = previousScrollRestoration;
    };
  }, []);

  useLayoutEffect(() => {
    const previousPathname = previousPathnameRef.current;
    const pendingStoreReturn = getStoreListingReturnPosition({
      hash,
      key,
      pathname,
      search,
    });
    let stopScheduledScroll = () => {};

    previousPathnameRef.current = pathname;

    if (pendingStoreReturn) {
      // ProductGrid restores Store pages after async product cards render.
    } else if (
      pathname !== "/store"
      && (previousPathname !== pathname || navigationType === "POP")
    ) {
      stopScheduledScroll = resetDocumentScrollPosition();
    }

    return () => {
      stopScheduledScroll();
    };
  }, [hash, key, navigationType, pathname, search]);

  return null;
}

function App() {
  return(
    <>
  <Router>
  <AuthProvider>
    <CartProvider>
      <WishlistProvider>
          <ScrollRestoration />
          <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            minHeight: '100vh' 
          }}>
            <Navbar />
            <main style={{ flex: 1 }}>
              <Routes>
                <Route path="/login" element={<LoginSignupPage />} />
                <Route path="/register" element={<Register />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/verify-otp" element={<OTPVerification />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/password/reset/:token" element={<ResetPassword />} />
                <Route path="/store" element={<ProductsPage />} />
                <Route path="/one-eyed-coconut-details" element={<OneEyedCoconutDetails />} />
                <Route path="/spiritual-collection/one-eyed-coconut/details" element={<OneEyedCoconutDetails />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/wishlist" element={<WishlistPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/order-confirmation" element={<OrderConfirmationPage />} />
                <Route path="/order/:id" element={<OrderTrackingPage />} />
                <Route path="/order" element={<OrderTrackingPage />} />
                <Route path="/review" element={<ReviewSubmissionPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/bespoke-jewelry" element={<BespokeJewelryPage />} />
                <Route path="/terms" element={<TermsAndConditions />} />
                <Route path="/more" element={<MoreAtJewelboon />} />
                <Route path="/payment-failed" element={<PaymentFailedPage />} />
                <Route path="/" element={<Home/>} />
              </Routes>
            </main>
            <Footer/>
          </div>
      </WishlistProvider>
    </CartProvider>
  </AuthProvider>
  </Router>
    </>
  )
}

export default App;
